/* eslint-disable indent */

import Mutation from "./mutationTypes";
import Action from "./actionTypes";
import Client from "../Client";
import Getter from "./getters";
export type TransactionPlan = {
    number: number,
    name: string,
    average_daily_balance: number,
    monthly_rate: number,
    base_rate: number,
    finance_charge: number,
    min_payment: number,
    plan_open_date: string,
}
export type Statement = {
    account_number: string,
    address: string,
    amount_avoid_interest: number,
    available_credit: number,
    city: string,
    ctd_billed_fees: number,
    ctd_billed_interest: number,
    current_balance: number,
    full_name: string,
    id: number,
    limit: number,
    message_1: string,
    message_2: string,
    message_3: string,
    min_payment_due: number,
    past_due: number,
    payment_due_date: string,
    payoff_36_mo_cost: number,
    payoff_36_mo_min_payment: number,
    payoff_cost: number,
    payoff_term: string,
    plan_previous_balance: number,
    state: string,
    statement_date: string,
    total_amount_credits: number,
    total_amount_debits: number,
    total_amount_due: number,
    transaction_plans: Array<TransactionPlan>,
    transactions: Array<Transaction>
}
type State = {
    abrv: string,
    name: string,
    id: number
}
export type Address = {
    id: number
    address: string,
    city: string,
    zip: string,
    state: State,
}
type state = {
    current_statement: Statement,
    logged_in: boolean,
    mail_address: Address
}
const mutations: { [key in Mutation]: ((state: state, arg1: any) => any) } = {
    [Mutation.INIT_USER](state: state, payload: any) {
        // state.account_number = payload.account_number;
    },
    [Mutation.SET_CURRENT_STATEMENT](state: state, current_statement: Statement) {
        state.current_statement = current_statement;
    },
    [Mutation.SET_LOGGED_IN](state: state, value: boolean) {
        state.logged_in = value;
    },
    [Mutation.SET_MAIL_ADDRESS](state: state, value: Address) {
        state.mail_address = value;
    }
};
const getters: { [key in Getter]: any } = {
    [Getter.TRANSACTIONS]: (state: state) => () => {
        return state.current_statement.transactions;
    },
    [Getter.STATEMENT]: (state: state) => () => {
        return state.current_statement;
    },
    [Getter.LOGGED_IN]: (state: state) => () => {
        return state.logged_in || Client.jwt_valid;
    },
    [Getter.MAIL_ADDRESS]: (state: state) => () => {
        return state.mail_address;
    }
};
const state: () => any = () => {
    return {
        // eslint-disable-next-line no-labels
        // eslint-disable-next-line no-unused-labels
        current_statement: {
            transactions: []
        }
    }
};
type login_credentials = { email: string, password: string }
type confirmation_credentials = { confirmation_code: string, phone_number: string }
type signup_credentials = {
    email: string,
    password: string,
    account_number: string,
    phone_number: string,
    first_name: string,
    last_name: string
};
export type Transaction = {
    credit_plan: string,
    effective_date: Date,
    reference_number: string,
    description: string,
    amount: string
}
const actions = {
    [Action.LOGIN](context: any, login_credentials: login_credentials) {
        context.commit(Mutation.SET_LOGGED_IN, true);
        return Client.postSaveCredentials("auth/login", login_credentials);
    },
    [Action.SIGNUP](context: any, signup_credentials: signup_credentials) {
        return Client.post("auth/signup", signup_credentials);
    },
    [Action.CONFIRM_ACCOUNT](context: any, credentials: confirmation_credentials) {
        return Client.postSaveCredentials("auth/confirm", credentials);
    },
    [Action.RESEND_CONFIRMATION](context: any, info: { phone_number: string }) {
        return Client.post("auth/resend", info);
    },
    async [Action.FETCH_CURRENT_STATEMENT](context: any, _: any) {
        const response = await Client.get<Statement>("api/latest_statement");
        context.commit(Mutation.SET_CURRENT_STATEMENT, response.data);
    },
    [Action.LOGOUT](context: any, _: any) {
        localStorage.setItem("refresh_token", "");
        context.commit(Mutation.SET_LOGGED_IN, false);
        return Client.post("/auth/logout", {});
    },
    async [Action.LOAD_ADDRESS](context: any, _: any) {
        const response = await Client.get<Address>("api/address");
        context.commit(Mutation.SET_MAIL_ADDRESS, response.data);
    },
    [Action.SAVE_ADDRESS](context: any, address: Address) {
        return Client.put<Address>("api/address", address);
    }
};
export default {
    mutations,
    getters,
    state,
    actions
};
